import { serviceTypeForHomePage } from '@shared/service_types'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Hooks } from 'service-api'
import { useRoutes } from 'app/use_routes'

export const RedirectPage = () => {
  const { accountName: locationName = '' } = useParams()
  const serviceTypes = Hooks.useClientLocationServiceType(locationName, {
    restrictions: true,
  })
  const { buildPath } = useRoutes()

  useEffect(() => {
    if (serviceTypes.isSuccess) {
      const stRedirect = serviceTypeForHomePage(serviceTypes.data.results)
      if (stRedirect) {
        window.location.href = buildPath('searchServiceType', {
          accountName: locationName,
          serviceTypeName: stRedirect?.serviceType?.name || 'boarding',
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serviceTypes.isSuccess])

  return null
}
